import React from 'react'
import cn from 'classnames'
import styles from './multi-column.module.scss'

interface MultiColumnLayoutProps {
  children?: React.ReactNode
  maxColumnsPerRow: number
  withDivider?: boolean
  minColumnsPerRow?: number
  multiColumnAsSingle?: boolean
  compact?: boolean
}
export const MultiColumnLayout: React.FC<MultiColumnLayoutProps> = ({
  children,
  withDivider,
  multiColumnAsSingle,
  maxColumnsPerRow = 2,
  minColumnsPerRow = maxColumnsPerRow,
  compact,
}) => {
  const layoutStyles = {
    '--multiColumnMaxColumnsPerRow': maxColumnsPerRow,
    '--multiColumnMinColumnsPerRow': minColumnsPerRow ?? maxColumnsPerRow,
  } as React.CSSProperties

  const layoutClass = cn(styles.multiColumn, {
    [styles.multiColumnWithDivider]: withDivider,
  })

  const content = (
    <div
      style={layoutStyles}
      className={cn(layoutClass, {
        [styles.multiColumnAsSingle]: multiColumnAsSingle,
        [styles.multiColumn]: !multiColumnAsSingle,
        [styles.multiColumnCompact]: compact,
      })}
    >
      {children}
    </div>
  )
  return multiColumnAsSingle ? <div className={styles.wrapper}>{content}</div> : content
}
